module.exports = __webpack_public_path__ + "img/transport.4f652e46.jpg";